import { Validator } from '@vista-digital/validator';
import { defaultFilmTrailerConfig, filmTrailerConfigValidator } from '../../trailer/types/config';
import { defaultFilmTrailerButtonAssets, filmTrailerButtonAssetsValidator } from './assets';
import { defaultFilmTrailerButtonDisplayText, filmTrailerButtonDisplayTextValidator } from './display-text';
import { filmTrailerButtonEventsValidator } from './events';
export const defaultFilmTrailerButtonProps = {
    displayText: defaultFilmTrailerButtonDisplayText,
    assets: defaultFilmTrailerButtonAssets,
    config: defaultFilmTrailerConfig,
    events: {}
};
export const filmTrailerButtonPropsValidator = Validator.object({
    displayText: filmTrailerButtonDisplayTextValidator,
    assets: filmTrailerButtonAssetsValidator,
    config: filmTrailerConfigValidator,
    events: filmTrailerButtonEventsValidator
});
